import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space, Select } from "@masterteam/mt-design-react";

import DashboardCard from "../DashboardCard";
import { useIsAr } from "../../../Hooks";

import "./style.scss";

const CardsSection = ({
  data,
  kpiStatuses,
  projectStatuses,
  title,
  isSectors = false,
  filterValue,
  filtersList,
  filtersLabel = null,
  handleFilterOnChange,
}) => {
  const [isAr] = useIsAr();

  return (
    <Space direction="vertical" className="cards-section" size="large" gap={30}>
      <Row
        size="large"
        align="center"
        justify="between"
        className="cards-section__header"
      >
        <div className="cards-section__title">
          <FormattedMessage id={title} />
        </div>

        {filtersLabel ? (
          <Space align="center" className="cards-section__field-wrapper">
            <div className="cards-section__title">
              <FormattedMessage id={filtersLabel} />
            </div>
            <Select
              options={filtersList}
              placeholder={<FormattedMessage id={filtersLabel} />}
              getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
              getOptionValue={(el) => el?.ID}
              onChange={handleFilterOnChange}
              value={filterValue}
              className="cards-section__select"
              isMulti
            />
          </Space>
        ) : null}
      </Row>

      {data?.length ? (
        <div className="cards-section__cards">
          {data?.map((e) => (
            <DashboardCard
              data={e}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              key={e.ID}
              width="100%"
              isSectorCard={isSectors}
            />
          ))}
        </div>
      ) : (
        <Row
          justify="center"
          align="center"
          style={{ paddingTop: "16px", fontSize: "14px" }}
        >
          <FormattedMessage id="no-data" />
        </Row>
      )}
    </Space>
  );
};

export default CardsSection;
